import { Leaf, Salad, Flame, AlertTriangle, Sparkles, Home, CalendarClock, MapPin } from "lucide-react";

const OPTIONS = [
  { id: "vegetariano", label: "Vegetariano", icon: Leaf, color: "text-green-600" },
  { id: "vegano", label: "Vegano", icon: Salad, color: "text-green-700" },
  { id: "picante", label: "Picante", icon: Flame, color: "text-red-500" },
  { id: "muy_picante", label: "Muy picante", icon: AlertTriangle, color: "text-red-700" },
  { id: "nuevo", label: "Nuevo", icon: Sparkles, color: "text-blue-600" },
  { id: "casero", label: "Casero", icon: Home, color: "text-amber-600" },
  { id: "temporada", label: "De temporada", icon: CalendarClock, color: "text-purple-600" },
  { id: "local", label: "Productos locales", icon: MapPin, color: "text-teal-600" },
];

export default function OptionsSelector({ selectedOptions = [], onChange }) {
  const handleOptionToggle = (optionId) => {
    const newOptions = selectedOptions.includes(optionId)
      ? selectedOptions.filter(o => o !== optionId)
      : [...selectedOptions, optionId];
    onChange(newOptions);
  };

  return (
    <div>
      <h4 className="font-semibold mb-3 text-gray-900">Opciones</h4>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        {OPTIONS.map((option) => {
          const Icon = option.icon;
          const isSelected = selectedOptions.includes(option.id);
          return (
            <label
              key={option.id}
              className={`flex items-center gap-2 cursor-pointer p-3 rounded-lg border-2 transition ${
                isSelected
                  ? "border-emerald-500 bg-emerald-50"
                  : "border-gray-200 hover:border-emerald-300"
              }`}
            >
              <input
                type="checkbox"
                checked={isSelected}
                onChange={() => handleOptionToggle(option.id)}
                className="w-4 h-4 text-emerald-600 rounded focus:ring-emerald-500"
              />
              <Icon className={`w-5 h-5 ${option.color}`} />
              <span className="text-sm font-medium text-gray-700">{option.label}</span>
            </label>
          );
        })}
      </div>
    </div>
  );
}

export { OPTIONS };
